import React from 'react';
import { useTranslation } from 'react-i18next';
import { BdsIcon } from '@/core/constants/webComponents';
import { showFilterBarButtonTooltip } from './tooltipPosition';

interface OpenFilterButtonProps {
  onClick: () => void;
  showTooltip: (left: number, top: number, items: string[], rightAligned?: boolean) => void;
  hideTooltip: () => void;
  isActive?: boolean;
}

export const OpenFilterButton: React.FC<OpenFilterButtonProps> = ({ onClick, showTooltip, hideTooltip, isActive = false }) => {
  const { t } = useTranslation();
  const showCurrentTooltip = (target: HTMLElement) => {
    showFilterBarButtonTooltip(target, t('filterBar.openFilter'), showTooltip);
  };

  return (
    <div className={`__icon-button __tooltip-wrapper filter-bar__open-filter-button${isActive ? ' filter-bar__open-filter-button--active' : ''}`}>
      <button
        type="button"
        className="filter-bar__action-button"
        data-testid="btn-open-filter"
        onClick={onClick}
        onMouseEnter={(e) => showCurrentTooltip(e.currentTarget)}
        onFocus={(e) => showCurrentTooltip(e.currentTarget)}
        onTouchStart={(e) => showCurrentTooltip(e.currentTarget)}
        onMouseLeave={hideTooltip}
        onBlur={hideTooltip}
        onTouchEnd={hideTooltip}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
          <BdsIcon name="filter" theme="outline" size="medium" color="surface-0" />
        </div>
      </button>
    </div>
  );
};
